import {Injectable, OnDestroy} from '@angular/core';
import {LovValue} from '../../api/model/LovValue.model';
import {LovValueSummary} from '../../api/model/lovValueSummary.model';
import {LovValueRepository} from './ngrx/lovValue.repository';
import {LovValueSummaryDataServiceAdapter} from './ngrx/lovValueSummaryDataService.adapter';
import {AbstractFindAllService} from '../../../../../core/service/v2/service/findAll/abstractFindAll.service';
import {LovValueCacheService} from "../../api/service/lovValueCache.service";

@Injectable()
export class LovValueSummaryFindAllService
    extends AbstractFindAllService<LovValue, LovValueSummary>
    implements OnDestroy{

    constructor(repository: LovValueRepository, dataServiceAdapter: LovValueSummaryDataServiceAdapter,
                private lovValueCacheService: LovValueCacheService) {
        super(repository, dataServiceAdapter);
    }

    ngOnDestroy(): void {
        super.onDestroy();
    }

    protected onEntityLoaded(entities: LovValueSummary[]) {
        entities?.forEach(value => this.lovValueCacheService.putInCache(value));
    }

}
